module.exports = __webpack_public_path__ + "static/img/jiangxi.4f233810.jpg";